// trackEcommerceOrder

export const matomoPurchase = (g_params) => {
  if (!window._paq) {
    setTimeout(() => {
      matomoPurchase(g_params)
    }, 100);
    return
  }
  const { remarketing_params, order_params } = g_params
  for (var i = 0; i < order_params.lineitems.length; i++) {
    window._paq.push(['addEcommerceItem', {
      sku: order_params.lineitems[i].SKU,
      name: order_params.lineitems[i].productName,
      productCategory: order_params.lineitems[i].categoryName,
      price: order_params.lineitems[i].unitPrice,
      quantity: order_params.lineitems[i].quantity
    }]);
  }
  window._paq.push(['trackEcommerceCartUpdate', parseFloat(remarketing_params.ecomm_totalvalue.toFixed(2))]);
  window._paq.push(['trackEcommerceOrder',
    order_params.orderid,
    parseFloat(remarketing_params.ecomm_totalvalue.toFixed(2)),
    order_params.taxAmount,
    0
  ]);
  window._paq.push(['setCustomDimension', 29, order_params.orderid])
  window._paq.push(['trackPageView']);
};

export const matomoSetCustomDimension = (dimension, value, retry = 0) => {
  const MAX_RETRIES = 200;
  const RETRY_DELAY = 200;

  if (!window._paq) {
    if (retry < MAX_RETRIES) {
      setTimeout(() => {
        matomoSetCustomDimension(dimension, value, retry + 1);
      }, RETRY_DELAY);
    } else {
      console.warn('Matomo _paq is not available after maximum retries.');
    }
    return;
  }

  window._paq.push(['setCustomDimension', dimension, value]);
  window._paq.push(['trackPageView']);
};

// 添加一个新的异步版本，用于在页面跳转前确保事件发送
// 注意：此函数有最大等待时间限制，确保不会因为统计功能阻塞业务流程
export const matomoSetCustomDimensionAsync = (dimension, value, options = {}) => {
  const MAX_TOTAL_WAIT = options.maxWait || 500; // 总共最多等待 500ms
  const startTime = Date.now();

  return new Promise((resolve) => {
    const attemptSend = (retry = 0) => {
      const elapsed = Date.now() - startTime;
      
      // 超时保护：如果已经等待超过最大时间，直接放行
      if (elapsed >= MAX_TOTAL_WAIT) {
        console.warn('Matomo event sending timeout, proceeding anyway.');
        resolve();
        return;
      }

      // 检查 window._paq 是否可用
      if (!window._paq) {
        const remainingTime = MAX_TOTAL_WAIT - elapsed;
        if (remainingTime > 50 && retry < 10) {
          // 还有时间，继续重试
          setTimeout(() => attemptSend(retry + 1), 50);
        } else {
          // 时间不够或重试次数用尽，直接放行
          console.warn('Matomo _paq is not available, proceeding without tracking.');
          resolve();
        }
        return;
      }

      // 发送事件
      try {
        window._paq.push(['setCustomDimension', dimension, value]);
        window._paq.push(['trackPageView']);
        
        // 给予 300ms 时间让事件发送出去（在总超时限制内）
        const waitTime = Math.min(300, MAX_TOTAL_WAIT - elapsed);
        setTimeout(() => {
          resolve();
        }, waitTime);
      } catch (error) {
        console.error('Error sending Matomo event:', error);
        resolve(); // 即使出错也要 resolve，不阻塞业务
      }
    };

    attemptSend();
  });
};


export const matomoSetArrCustomDimension = (arr, retry = 0) => {
  const MAX_RETRIES = 200;
  const RETRY_DELAY = 200;

  if (!window._paq) {
    if (retry < MAX_RETRIES) {
      setTimeout(() => {
        matomoSetCustomDimension(dimension, value, retry + 1);
      }, RETRY_DELAY);
    } else {
      console.warn('Matomo _paq is not available after maximum retries.');
    }
    return;
  }
  arr.forEach((item) => {
    window._paq.push(['setCustomDimension', item.dimension, item.value]);
  });
  window._paq.push(['trackPageView']);
};